import { Redemption } from '../../runtypes/RedemptionRuntype';

export function getRedemptionAmount(input: {
  amountInCents: number;
  redemption?: Omit<Redemption, 'addAbsValueToSalesTotal'> & {
    addAbsValueToSalesTotal?: boolean | null;
  };
}) {
  const { amountInCents, redemption } = input;
  if (!redemption) {
    return 0;
  }
  const modifiedAmount =
    redemption.invoiceTotalModifier === 'subtract'
      ? Math.abs(amountInCents) * -1
      : redemption.invoiceTotalModifier === 'add'
      ? Math.abs(amountInCents)
      : 0;
  return modifiedAmount;
}
